export default __webpack_public_path__ + "static/media/sector_1.ba88c267.jpg";